import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { BRANDING } from "@/branding";
import { Sparkles } from "lucide-react";

export default function About() {
  return (
    <div className="min-h-screen flex flex-col bg-cream" data-testid="about-page">
      <Header />
      <section className="max-w-3xl mx-auto px-5 lg:px-10 py-20">
        <div className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.25em] text-gold">
          <Sparkles className="h-3.5 w-3.5" /> About the shop
        </div>
        <h1 className="editorial font-serif-display text-4xl sm:text-5xl mt-4 leading-tight text-plum-deep">
          Thoughtful digital products — made with intention.
        </h1>
        <p className="mt-6 text-plum/80 leading-relaxed">
          {BRANDING.storeName} is a small, independent studio for original digital products — planners, worksheets, business and DIY guides, wellness kits, home and travel resources, creator templates and reflective tarot workbooks. Every item is created to help you make real-world progress at your own pace.
        </p>
        <p className="mt-4 text-plum/80 leading-relaxed">
          {BRANDING.tagline}
        </p>
        <p className="mt-4 text-plum/80 leading-relaxed">
          Purchases are delivered instantly after checkout, and the download links are also sent to your email so you always have them handy.
        </p>
      </section>
      <Footer />
    </div>
  );
}
